import { Injectable } from '@angular/core';
import { BRAND_PROFILES, DEFAULT_BRAND_ID } from '../../config/brand-profiles';
import { BrandId, BrandProfile } from './brand.model';

@Injectable({ providedIn: 'root' })
export class BrandService {
  private readonly profiles = BRAND_PROFILES;
  private readonly activeBrand = this.resolveBrand(this.getHostname());

  public get brand(): BrandProfile {
    return this.activeBrand;
  }

  public get brandId(): BrandId {
    return this.activeBrand.id;
  }

  public buildPageTitle(page: string): string {
    return `${this.activeBrand.pageTitlePrefix} - ${page}`;
  }

  private resolveBrand(hostname: string): BrandProfile {
    const normalizedHost = hostname.toLowerCase();

    if (normalizedHost.includes('aranconta')) {
      const aranconta = this.profiles.find((profile) => profile.id === 'aranconta');
      if (aranconta) {
        return aranconta;
      }
    }

    const matched = this.profiles.find((profile) =>
      profile.domains.some((domain) => this.matchesDomain(normalizedHost, domain))
    );

    if (matched) {
      return matched;
    }

    const fallback = this.profiles.find((profile) => profile.id === DEFAULT_BRAND_ID);
    if (!fallback) {
      throw new Error(`Default brand profile "${DEFAULT_BRAND_ID}" is not configured`);
    }

    return fallback;
  }

  private matchesDomain(hostname: string, domain: string): boolean {
    const normalizedDomain = domain.toLowerCase();

    if (hostname === normalizedDomain) {
      return true;
    }

    return hostname.endsWith(`.${normalizedDomain}`);
  }

  private getHostname(): string {
    if (typeof window === 'undefined' || !window.location?.hostname) {
      return 'localhost';
    }

    return window.location.hostname;
  }
}
